export default __webpack_public_path__ + "static/media/kerjoo-desk-logo-dark.2a80858f.png";